import { render } from "./PillsLayout.vue?vue&type=template&id=57740d71"
const script = {}
script.render = render

export default script